import { useInvoicesTableContext } from '../components/providers/InvoicesTableProvider.graphql';
import { useFeatureFlag } from '@orthly/veneer';

/**
 * Utility hook that returns true if multi location billing is enabled for this session.
 * This requires that:
 *  - The current organization is the primary organization in the contract
 *  - There are more than 1 practices in the contract
 *  - (NEW) The user isn't explicitly banned from accessing by Feature Flag
 */
export function useIsMultiLocationBillingEnabled() {
    const { isPracticePrimaryForContract, associatedPractices } = useInvoicesTableContext();

    // This feature flag is only meant to be used in very specific edge cases.
    // In particular, we are using it to limit access to multi-location billing for our new DSO being onboarded.
    const { value: isDisabledByFeatureFlag } = useFeatureFlag('multiLocationBillingDisabledForUser');
    if (isDisabledByFeatureFlag) {
        return false;
    }

    return isPracticePrimaryForContract && associatedPractices.length > 1;
}
